/**
 * 2020-08-04
 * handan
 * 显示用户上报时机
 */

import moment from "moment";

/**
 * 每天的8点 - 12点 下午 2点 - 4点限制流量
 * @param {number} percent 填几，就取几分之一 
 */
function handleAjaxLimit(percent){
  let hour = moment().format("HH") * 1 ;
  if((8 <= hour && hour <= 12) || (14 <= hour && hour <= 16)){
    let num = Math.floor(Math.random() * percent) + 1 ;
    if(num === 1){
      return true ;
    }else{
      return false ;
    }
  }else{
    return true ;
  }
}

export default handleAjaxLimit ;